// Module
var code = "<div *ngIf=\"text\" class=\"alert alert-danger\"> {{text | localize }} </div>";
// Exports
module.exports = code;